import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { IncExcKeyVO } from '@wizeoo/akm-common-lib';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

/**
 * renderer d'une colonne avec icone close pour le ag-grid
 */
@Component({
  selector: 'incex-renderer',
  template: `<wiz-hgroup height="100%" width="100%" verticalAlign="center" horizontalAlign="center">
    <wiz-icon *ngIf="isInc">play</wiz-icon>
    <wiz-icon *ngIf="!isInc">cancel</wiz-icon>
  </wiz-hgroup>`,
  styles: [':host {height:100%; width: 100%; max-width: 100%}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncExcWayRenderer implements AgRendererComponent {
  data: IncExcKeyVO;
  public isInc: boolean = true;

  constructor(private cdref: ChangeDetectorRef) {}

  public refresh(params: ICellRendererParams): boolean {
    this.data = params.data;
    this.isInc = this.data.inc;
    this.cdref.markForCheck();
    return true;
  }

  public agInit(params: ICellRendererParams) {
    this.data = params.data;
    this.isInc = this.data.inc;
    this.cdref.markForCheck();
  }
}
